import { Router } from '@angular/router';
import { ServiceAdminService } from '../Providers/service-admin.service';
import { Component, OnInit } from '@angular/core';
import { CoreService } from "../Providers/core.service";
import { Location } from '@angular/common';
/**
 * created by AHMED HAYEL
 */

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.css']
})
export class ErrorComponent implements OnInit {

  constructor(private coreService: CoreService, private _location: Location, private service: ServiceAdminService, private router: Router) {
    coreService.changeBackgroundImageTo(0);
  }

  ngOnInit() {
  }
  back() {
    //this._location.back();
    this.router.navigate(['/authentification'])
  }

}



// WEBPACK FOOTER //
// ./src/app/error/error.component.ts